import React, { useContext } from 'react';

import { SiteNavigation } from '@motorway/mw-dealer-shared-components/components';

import { FeaturesContext } from 'Context/FeaturesContext/FeaturesContext';
import useUser from 'Utilities/hooks/useUser';

import { usePageComposerSiteNavigation } from './hooks/usePageComposerSiteNavigation';

export const PageComposerSiteNavigation: React.FC = () => {
	const features = useContext(FeaturesContext);
	const user = useUser();

	const { activeItemId, handlers, hasBottomBorder, isHidden, isSticky, isTransparent, permissions } =
		usePageComposerSiteNavigation();

	if (isHidden) {
		return null;
	}

	return (
		<SiteNavigation
			activeItemId={activeItemId}
			dataAttributes={{}}
			features={features}
			handlers={handlers}
			hasBottomBorder={hasBottomBorder}
			isSticky={isSticky}
			isTransparent={isTransparent}
			permissions={permissions}
			user={user}
		/>
	);
};
